export let Tab = /*#__PURE__*/function (Tab) {
  Tab["Vendor"] = "vendor";
  Tab["Client"] = "customer";
  return Tab;
}({});
export let Table = /*#__PURE__*/function (Table) {
  Table["Notifications"] = "notifications";
  Table["Reminders"] = "reminders";
  return Table;
}({});
export const notificationColumnDefs = [{
  width: [600, 600]
}, {
  width: [160, 200]
}, {
  width: [160, 200]
}];
export const notificationHeaderItems = [{
  value: 'Event Name'
}, {
  value: 'Status'
}, {
  value: 'Notified Team Member'
}];
const clientReminderColumnDefs = [{
  width: [600, 600]
}, {
  width: [100, 200]
}, {
  width: [80, 200]
}, {
  width: [60, 200]
}, {
  width: [160, 200]
}];
const clientReminderHeaderItems = [{
  value: 'Delayed Action'
}, {
  value: 'Status'
}, {
  value: 'Interval'
}, {
  value: 'Retries'
}, {
  value: 'Notified Team Member'
}];
const vendorReminderColumnDefs = [{
  width: [600, 600]
}, {
  width: [160, 200]
}, {
  width: [80, 200]
}, {
  width: [160, 200]
}];
const vendorReminderHeaderItems = [{
  value: 'Delayed Action'
}, {
  value: 'Status'
}, {
  value: 'Delay'
}, {
  value: 'Notified Team Member'
}];
export const reminderColumnDefsMap = {
  [Tab.Vendor]: vendorReminderColumnDefs,
  [Tab.Client]: clientReminderColumnDefs
};
export const reminderHeaderItemsMap = {
  [Tab.Vendor]: vendorReminderHeaderItems,
  [Tab.Client]: clientReminderHeaderItems
};
const vendorNotificationToShowTextMap = {
  relationshipApprovedVendor: 'Proposal signed',
  relationshipAmendmentsApprovedVendor: 'Amendment approved',
  paymentFailedVendor: 'Payment failed',
  invoiceRefundedVendor: 'Payment refunded',
  payoutDepositedVendor: 'Payout deposited',
  proposalNotSignedReminderVendor: 'Proposal not signed',
  amendmentsNotApprovedReminderVendor: 'Amendment not approved'
};
const clientNotificationToShowTextMap = {
  invoiceIssuedAutoProcess: 'Invoice issued',
  invoiceIssuedRequiresApproval: 'Invoice requires approval',
  paymentFailedCustomer: 'Payment failed',
  relationshipUpdatedWithChanges: 'Agreement amended',
  invoiceRefundedCustomer: 'Payment refunded',
  proposalNotSignedReminderCustomer: 'Proposal not signed'
};
export const notificationsToShow = {
  [Tab.Vendor]: vendorNotificationToShowTextMap,
  [Tab.Client]: clientNotificationToShowTextMap
};
export const vendorProposalNotifications = ['proposalNotSignedReminderVendor', 'relationshipApprovedVendor'];
export const getRecipientTypeTextMap = notificationName => ({
  member: 'All team members',
  owner: 'Owner',
  admin: 'Admin',
  assignee: vendorProposalNotifications.includes(notificationName) ? 'Sender' : 'Assigned Team Member'
});
export const allRecipientTypes = ['member', 'owner', 'admin', 'assignee'];
export const getEditDropdownRecipientTypeText = notificationName => ({
  member: 'All team members',
  owner: 'Users with Owner role',
  admin: 'Users with Admin role',
  assignee: vendorProposalNotifications.includes(notificationName) ? 'Sender' : 'Assigned Team Member'
});
export const getRecipientTypesText = (recipientTypes, notificationName) => recipientTypes.includes('member') ? [getRecipientTypeTextMap(notificationName).member] : recipientTypes.map(recipientType => getRecipientTypeTextMap(notificationName)[recipientType]);
export const minutesToDays = minutes => Math.floor(minutes / 60 / 24);
export const daysToMinutes = days => days * 60 * 24;
export const isDays = minutes => minutes % (60 * 24) === 0;